/**
 * <ActivationStudentHeaderSkeleton> — la forme de `<ActivationStudentHeader>` pendant un chargement.
 *
 * La pastille à sa taille (`AVATAR_SIZE`), la légende vraie — elle ne dépend d'aucune donnée — et
 * la place du prénom, à la hauteur du `<Title>`.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { AVATAR_SIZE } from "./ActivationStudentHeader"

export function ActivationStudentHeaderSkeleton() {
    return (
        <Row gap="3">
            <Skeleton shape="circle" size={AVATAR_SIZE} />
            <Stack gap="0" style={styles.body}>
                <SectionLabel color="role">Mon abonnement</SectionLabel>
                <Skeleton textSize="text-2xl" width={110} />
            </Stack>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flexShrink: 1, flexGrow: 1 },
}))
